import { GDFHotPolyRecordNormal } from '../../../gdf/type';

export default function TfrTooltip({ record }: { record: GDFHotPolyRecordNormal }) {
    return <div>{record.label}</div>;
}
